import { f as fetchConfig } from "@theme/utils";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var toastify$1 = { exports: {} };
var toastify = toastify$1.exports;
var hasRequiredToastify;
function requireToastify() {
  if (hasRequiredToastify) return toastify$1.exports;
  hasRequiredToastify = 1;
  (function(module) {
    (function(root, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        root.Toastify = factory();
      }
    })(toastify, function(global) {
      var Toastify2 = function(options) {
        return new Toastify2.lib.init(options);
      }, version = "1.12.0";
      Toastify2.defaults = {
        oldestFirst: true,
        text: "Toastify is awesome!",
        node: void 0,
        duration: 3e3,
        selector: void 0,
        callback: function() {
        },
        destination: void 0,
        newWindow: false,
        close: false,
        gravity: "toastify-top",
        positionLeft: false,
        position: "",
        backgroundColor: "",
        avatar: "",
        className: "",
        stopOnFocus: true,
        onClick: function() {
        },
        offset: { x: 0, y: 0 },
        escapeMarkup: true,
        ariaLive: "polite",
        style: { background: "" }
      };
      Toastify2.lib = Toastify2.prototype = {
        toastify: version,
        constructor: Toastify2,
        // Initializing the object with required parameters
        init: function(options) {
          if (!options) {
            options = {};
          }
          this.options = {};
          this.toastElement = null;
          this.options.text = options.text || Toastify2.defaults.text;
          this.options.node = options.node || Toastify2.defaults.node;
          this.options.duration = options.duration === 0 ? 0 : options.duration || Toastify2.defaults.duration;
          this.options.selector = options.selector || Toastify2.defaults.selector;
          this.options.callback = options.callback || Toastify2.defaults.callback;
          this.options.destination = options.destination || Toastify2.defaults.destination;
          this.options.newWindow = options.newWindow || Toastify2.defaults.newWindow;
          this.options.close = options.close || Toastify2.defaults.close;
          this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : Toastify2.defaults.gravity;
          this.options.positionLeft = options.positionLeft || Toastify2.defaults.positionLeft;
          this.options.position = options.position || Toastify2.defaults.position;
          this.options.backgroundColor = options.backgroundColor || Toastify2.defaults.backgroundColor;
          this.options.avatar = options.avatar || Toastify2.defaults.avatar;
          this.options.className = options.className || Toastify2.defaults.className;
          this.options.stopOnFocus = options.stopOnFocus === void 0 ? Toastify2.defaults.stopOnFocus : options.stopOnFocus;
          this.options.onClick = options.onClick || Toastify2.defaults.onClick;
          this.options.offset = options.offset || Toastify2.defaults.offset;
          this.options.escapeMarkup = options.escapeMarkup !== void 0 ? options.escapeMarkup : Toastify2.defaults.escapeMarkup;
          this.options.ariaLive = options.ariaLive || Toastify2.defaults.ariaLive;
          this.options.style = options.style || Toastify2.defaults.style;
          if (options.backgroundColor) {
            this.options.style.background = options.backgroundColor;
          }
          return this;
        },
        // Building the DOM element
        buildToast: function() {
          if (!this.options) {
            throw "Toastify is not initialized";
          }
          var divElement = document.createElement("div");
          divElement.className = "toastify on " + this.options.className;
          if (!!this.options.position) {
            divElement.className += " toastify-" + this.options.position;
          } else {
            if (this.options.positionLeft === true) {
              divElement.className += " toastify-left";
              console.warn("Property `positionLeft` will be depreciated in further versions. Please use `position` instead.");
            } else {
              divElement.className += " toastify-right";
            }
          }
          divElement.className += " " + this.options.gravity;
          if (this.options.backgroundColor) {
            console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
          }
          for (var property in this.options.style) {
            divElement.style[property] = this.options.style[property];
          }
          if (this.options.ariaLive) {
            divElement.setAttribute("aria-live", this.options.ariaLive);
          }
          if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) {
            divElement.appendChild(this.options.node);
          } else {
            if (this.options.escapeMarkup) {
              divElement.innerText = this.options.text;
            } else {
              divElement.innerHTML = this.options.text;
            }
            if (this.options.avatar !== "") {
              var avatarElement = document.createElement("img");
              avatarElement.src = this.options.avatar;
              avatarElement.className = "toastify-avatar";
              if (this.options.position == "left" || this.options.positionLeft === true) {
                divElement.appendChild(avatarElement);
              } else {
                divElement.insertAdjacentElement("afterbegin", avatarElement);
              }
            }
          }
          if (this.options.close === true) {
            var closeElement = document.createElement("button");
            closeElement.type = "button";
            closeElement.setAttribute("aria-label", "Close");
            closeElement.className = "toast-close";
            closeElement.innerHTML = "&#10006;";
            closeElement.addEventListener(
              "click",
              (function(event) {
                event.stopPropagation();
                this.removeElement(this.toastElement);
                window.clearTimeout(this.toastElement.timeOutValue);
              }).bind(this)
            );
            var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
            if ((this.options.position == "left" || this.options.positionLeft === true) && width > 360) {
              divElement.insertAdjacentElement("afterbegin", closeElement);
            } else {
              divElement.appendChild(closeElement);
            }
          }
          if (this.options.stopOnFocus && this.options.duration > 0) {
            var self = this;
            divElement.addEventListener(
              "mouseover",
              function(event) {
                window.clearTimeout(divElement.timeOutValue);
              }
            );
            divElement.addEventListener(
              "mouseleave",
              function() {
                divElement.timeOutValue = window.setTimeout(
                  function() {
                    self.removeElement(divElement);
                  },
                  self.options.duration
                );
              }
            );
          }
          if (typeof this.options.destination !== "undefined") {
            divElement.addEventListener(
              "click",
              (function(event) {
                event.stopPropagation();
                if (this.options.newWindow === true) {
                  window.open(this.options.destination, "_blank");
                } else {
                  window.location = this.options.destination;
                }
              }).bind(this)
            );
          }
          if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") {
            divElement.addEventListener(
              "click",
              (function(event) {
                event.stopPropagation();
                this.options.onClick();
              }).bind(this)
            );
          }
          if (typeof this.options.offset === "object") {
            var x = getAxisOffsetAValue("x", this.options);
            var y = getAxisOffsetAValue("y", this.options);
            var xOffset = this.options.position == "left" ? x : "-" + x;
            var yOffset = this.options.gravity == "toastify-top" ? y : "-" + y;
            divElement.style.transform = "translate(" + xOffset + "," + yOffset + ")";
          }
          return divElement;
        },
        // Displaying the toast
        showToast: function() {
          this.toastElement = this.buildToast();
          var rootElement;
          if (typeof this.options.selector === "string") {
            rootElement = document.getElementById(this.options.selector);
          } else if (this.options.selector instanceof HTMLElement || typeof ShadowRoot !== "undefined" && this.options.selector instanceof ShadowRoot) {
            rootElement = this.options.selector;
          } else {
            rootElement = document.body;
          }
          if (!rootElement) {
            throw "Root element is not defined";
          }
          var elementToInsert = Toastify2.defaults.oldestFirst ? rootElement.firstChild : rootElement.lastChild;
          rootElement.insertBefore(this.toastElement, elementToInsert);
          Toastify2.reposition();
          if (this.options.duration > 0) {
            this.toastElement.timeOutValue = window.setTimeout(
              (function() {
                this.removeElement(this.toastElement);
              }).bind(this),
              this.options.duration
            );
          }
          return this;
        },
        hideToast: function() {
          if (this.toastElement.timeOutValue) {
            clearTimeout(this.toastElement.timeOutValue);
          }
          this.removeElement(this.toastElement);
        },
        // Removing the element from the DOM
        removeElement: function(toastElement) {
          toastElement.className = toastElement.className.replace(" on", "");
          window.setTimeout(
            (function() {
              if (this.options.node && this.options.node.parentNode) {
                this.options.node.parentNode.removeChild(this.options.node);
              }
              if (toastElement.parentNode) {
                toastElement.parentNode.removeChild(toastElement);
              }
              this.options.callback.call(toastElement);
              Toastify2.reposition();
            }).bind(this),
            400
          );
        }
      };
      Toastify2.reposition = function() {
        var topLeftOffsetSize = {
          top: 15,
          bottom: 15
        };
        var topRightOffsetSize = {
          top: 15,
          bottom: 15
        };
        var offsetSize = {
          top: 15,
          bottom: 15
        };
        var allToasts = document.getElementsByClassName("toastify");
        var classUsed;
        for (var i = 0; i < allToasts.length; i++) {
          if (containsClass(allToasts[i], "toastify-top") === true) {
            classUsed = "toastify-top";
          } else {
            classUsed = "toastify-bottom";
          }
          var height = allToasts[i].offsetHeight;
          classUsed = classUsed.substr(9, classUsed.length - 1);
          var offset = 15;
          var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
          if (width <= 360) {
            allToasts[i].style[classUsed] = offsetSize[classUsed] + "px";
            offsetSize[classUsed] += height + offset;
          } else {
            if (containsClass(allToasts[i], "toastify-left") === true) {
              allToasts[i].style[classUsed] = topLeftOffsetSize[classUsed] + "px";
              topLeftOffsetSize[classUsed] += height + offset;
            } else {
              allToasts[i].style[classUsed] = topRightOffsetSize[classUsed] + "px";
              topRightOffsetSize[classUsed] += height + offset;
            }
          }
        }
        return this;
      };
      function getAxisOffsetAValue(axis, options) {
        if (options.offset[axis]) {
          if (isNaN(options.offset[axis])) {
            return options.offset[axis];
          } else {
            return options.offset[axis] + "px";
          }
        }
        return "0px";
      }
      function containsClass(elem, yourClass) {
        if (!elem || typeof yourClass !== "string") {
          return false;
        } else if (elem.className && elem.className.trim().split(/\s+/gi).indexOf(yourClass) > -1) {
          return true;
        } else {
          return false;
        }
      }
      Toastify2.lib.init.prototype = Toastify2.lib;
      return Toastify2;
    });
  })(toastify$1);
  return toastify$1.exports;
}
var toastifyExports = requireToastify();
const Toastify = /* @__PURE__ */ getDefaultExportFromCjs(toastifyExports);
class ProductCardWrapper extends HTMLElement {
  constructor() {
    super();
    this.variantData = null;
    this.currentVariant = null;
    this.cartDrawer = null;
    this.bundleMultiplier = 1;
    this.bundleDiscount = 0;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.initImageLoading();
    const productDataScript = this.querySelector(
      '[type="application/json"][data-product-variants]'
    );
    if (productDataScript) {
      this.variantData = JSON.parse(productDataScript.textContent);
    }
    this.cartDrawer = document.querySelector("cart-drawer");
    this.form = this.querySelector("form");
    if (!this.form) return;
    this.initializeVariant();
    this.attachEventListeners();
    requestAnimationFrame(() => this.initPillIndicators());
  }
  initImageLoading() {
    const mainImage = this.querySelector(".product-main-image");
    const placeholder = this.querySelector(".product-image-placeholder");
    if (!mainImage || !placeholder) return;
    const handleImageLoad = () => {
      mainImage.style.opacity = "1";
      placeholder.style.opacity = "0";
    };
    if (mainImage.complete && mainImage.naturalHeight > 0) {
      handleImageLoad();
    } else {
      mainImage.addEventListener("load", handleImageLoad, { once: true });
    }
  }
  initializeVariant() {
    this.currentVariant = this.variantData?.find((v) => v.available) || this.variantData?.[0];
    if (this.currentVariant) {
      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = this.currentVariant.id;
      }
    }
  }
  attachEventListeners() {
    const variantButtons = this.querySelectorAll(".variant-option-btn");
    variantButtons.forEach((button) => {
      button.addEventListener("click", this.onVariantButtonClick.bind(this));
    });
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector('[type="submit"]');
    this.isInlineCart = this.submitButton?.hasAttribute("data-inline-cart");
    if (this.isInlineCart) {
      this.inlineQty = this.querySelector("[data-inline-qty]");
      this.qtyValue = this.querySelector("[data-qty-value]");
      this.qtySpinner = this.querySelector("[data-qty-spinner]");
      this.quantity = 0;
      this.cartLineKey = null;
      const minusBtn = this.querySelector("[data-qty-minus]");
      const plusBtn = this.querySelector("[data-qty-plus]");
      minusBtn?.addEventListener(
        "click",
        () => this.updateQuantity(this.quantity - 1)
      );
      plusBtn?.addEventListener(
        "click",
        () => this.updateQuantity(this.quantity + 1)
      );
    }
  }
  onVariantButtonClick(evt) {
    const button = evt.currentTarget;
    const siblings = button.parentElement.querySelectorAll(
      ".variant-option-btn"
    );
    siblings.forEach((sibling) => sibling.classList.remove("active"));
    button.classList.add("active");
    this.movePillIndicator(button);
    if (button.dataset.bundleQty || button.parentElement.querySelector("[data-bundle-qty]")) {
      const bundleQty = parseInt(button.dataset.bundleQty) || 0;
      this.bundleMultiplier = bundleQty || 1;
      if (bundleQty > 0) {
        this.bundleDiscount = window.bundle_discounts?.[`bundle:${bundleQty}`] || 0;
      } else {
        this.bundleDiscount = 0;
      }
      const quantityInput = this.form?.querySelector("[data-quantity-input]");
      if (quantityInput) quantityInput.value = this.bundleMultiplier;
      this.updatePrice();
      this.updateBadge();
      return;
    }
    this.onVariantChange();
  }
  movePillIndicator(button) {
    const pills = button.closest(".variant-pills");
    if (!pills) return;
    const indicator = pills.querySelector(".variant-pill-indicator");
    if (!indicator) return;
    indicator.style.left = `${button.offsetLeft}px`;
    indicator.style.width = `${button.offsetWidth}px`;
  }
  initPillIndicators() {
    const pills = this.querySelectorAll(".variant-pills");
    const measurements = [];
    for (const group of pills) {
      const active = group.querySelector(".variant-option-btn.active");
      if (!active) continue;
      const indicator = group.querySelector(".variant-pill-indicator");
      if (!indicator) continue;
      measurements.push({ indicator, left: active.offsetLeft, width: active.offsetWidth });
    }
    for (const { indicator, left, width } of measurements) {
      indicator.style.transition = "none";
      indicator.style.left = `${left}px`;
      indicator.style.width = `${width}px`;
    }
    requestAnimationFrame(() => {
      for (const { indicator } of measurements) {
        indicator.style.transition = "";
      }
    });
  }
  onVariantChange() {
    if (this.isInlineCart) {
      this.hideInlineQty();
    }
    const selectedOptions = [];
    const optionGroups = {};
    this.querySelectorAll(".variant-option-btn").forEach((btn) => {
      const optionIndex = btn.getAttribute("data-variant-option");
      if (!optionGroups[optionIndex]) {
        optionGroups[optionIndex] = [];
      }
      optionGroups[optionIndex].push(btn);
    });
    Object.keys(optionGroups).sort().forEach((optionIndex) => {
      const activeButton = optionGroups[optionIndex].find(
        (btn) => btn.classList.contains("active")
      );
      if (activeButton) {
        selectedOptions.push(activeButton.getAttribute("data-option-value"));
      }
    });
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return selectedOptions[index] === option;
      }).includes(false);
    });
    if (this.currentVariant) {
      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = this.currentVariant.id;
      }
      this.updateAddButton();
      this.updatePrice();
      this.updateBadge();
    } else {
      this.setUnavailable();
    }
  }
  updateAddButton() {
    if (!this.submitButton) return;
    if (this.currentVariant && this.currentVariant.available) {
      this.submitButton.removeAttribute("disabled");
      this.submitButton.setAttribute("aria-label", "Add to Cart");
    } else {
      this.submitButton.setAttribute("disabled", "disabled");
      this.submitButton.setAttribute("aria-label", "Sold out");
    }
  }
  updatePrice() {
    const priceElement = this.querySelector("[data-product-price]");
    if (!priceElement || !this.currentVariant) return;
    const m = this.bundleMultiplier || 1;
    const discount = this.bundleDiscount || 0;
    const totalPrice = this.currentVariant.price * m;
    const comparePriceElement = this.querySelector(
      "[data-product-compare-price]"
    );
    const savingsElement = this.querySelector("[data-product-savings]");
    if (discount > 0) {
      const discountedPrice = Math.round(totalPrice * (1 - discount / 100));
      priceElement.textContent = this.formatMoney(discountedPrice);
      const compareTotal = this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price ? this.currentVariant.compare_at_price * m : totalPrice;
      if (comparePriceElement) {
        comparePriceElement.textContent = this.formatMoney(compareTotal);
        comparePriceElement.classList.remove("hidden");
      }
      if (savingsElement) {
        const saveLabel = document.documentElement.lang === "bg" ? "Спести" : "Save";
        const savedAmount = this.formatMoney(compareTotal - discountedPrice);
        savingsElement.textContent = `${saveLabel} ${savedAmount}`;
        savingsElement.classList.add("font-medium");
        savingsElement.classList.remove("hidden");
      }
    } else {
      priceElement.textContent = this.formatMoney(totalPrice);
      const onSale = this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price;
      if (comparePriceElement) {
        if (onSale) {
          comparePriceElement.textContent = this.formatMoney(
            this.currentVariant.compare_at_price * m
          );
          comparePriceElement.classList.remove("hidden");
        } else {
          comparePriceElement.classList.add("hidden");
        }
      }
      if (savingsElement) {
        if (onSale) {
          const savings = this.formatMoney(
            (this.currentVariant.compare_at_price - this.currentVariant.price) * m
          );
          const saveLabel = document.documentElement.lang === "bg" ? "Спести" : "Save";
          savingsElement.textContent = `${saveLabel} ${savings}`;
          savingsElement.classList.remove("hidden");
        } else {
          savingsElement.classList.add("hidden");
        }
      }
    }
  }
  updateBadge() {
    const badgesEl = this.querySelector("[data-product-badges]");
    if (!badgesEl || !this.currentVariant) return;
    const { price, compare_at_price, available } = this.currentVariant;
    const m = this.bundleMultiplier || 1;
    const bundleDiscount = this.bundleDiscount || 0;
    if (!available) {
      badgesEl.innerHTML = `<span class="product-badge product-badge--sold-out text-gray-light text-xxs inline-block rounded-full bg-black px-2 py-1 font-semibold sm:px-3 sm:text-sm">Sold out</span>`;
      return;
    }
    const totalPrice = price * m;
    const hasCompare = compare_at_price && compare_at_price > price;
    if (bundleDiscount > 0) {
      const discountedPrice = Math.round(
        totalPrice * (1 - bundleDiscount / 100)
      );
      const compareTotal = hasCompare ? compare_at_price * m : totalPrice;
      const pct = Math.round(
        (compareTotal - discountedPrice) / compareTotal * 100
      );
      badgesEl.innerHTML = `<span class="product-badge product-badge--discount bg-notice text-xxs inline-block rounded-full px-2 py-1 font-semibold text-white sm:px-3 sm:text-sm">- ${pct}%</span>`;
    } else if (hasCompare) {
      const pct = Math.round(
        (compare_at_price - price) / compare_at_price * 100
      );
      badgesEl.innerHTML = `<span class="product-badge product-badge--discount bg-notice text-xxs inline-block rounded-full px-2 py-1 font-semibold text-white sm:px-3 sm:text-sm">- ${pct}%</span>`;
    } else {
      badgesEl.innerHTML = "";
    }
  }
  formatMoney(cents) {
    if (window.money_format) {
      const amount = (cents / 100).toFixed(2);
      return window.money_format.replace("{{amount}}", amount).replace("{{amount_no_decimals}}", Math.floor(cents / 100)).replace("{{amount_with_comma_separator}}", amount.replace(".", ","));
    }
    const currency = window.Shopify?.currency?.active || "USD";
    const locale = window.Shopify?.locale || "en-US";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency
    }).format(cents / 100);
  }
  setUnavailable() {
    if (this.submitButton) {
      this.submitButton.setAttribute("disabled", "disabled");
      this.submitButton.setAttribute("aria-label", "Unavailable");
    }
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true" || this.submitButton.hasAttribute("disabled")) {
      return;
    }
    this.submitButton.setAttribute("aria-disabled", "true");
    this.submitButton.classList.add("loading");
    const btnText = this.submitButton.querySelector(".btn-text");
    const btnSpinner = this.submitButton.querySelector(".btn-spinner");
    if (btnText) btnText.style.opacity = "0";
    if (btnSpinner) btnSpinner.style.opacity = "1";
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(this.form);
    if (this.cartDrawer) {
      formData.append(
        "sections",
        this.cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      if (!this.isInlineCart) {
        this.cartDrawer.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;
    fetch(window.routes.cart_add_url, config).then((response) => response.json()).then((response) => {
      if (response.status) {
        this.handleError(response.description);
        return;
      }
      Toastify({
        text: (this.getAttribute("data-added-to-cart-text") || "__TITLE__ added to cart").replace("__TITLE__", response.product_title),
        duration: 3e3,
        gravity: "bottom",
        position: "right",
        stopOnFocus: true,
        style: { background: "#547744", borderRadius: "8px" }
      }).showToast();
      if (this.isInlineCart) {
        this.cartLineKey = response.key;
        this.quantity = response.quantity || 1;
        if (this.cartDrawer) {
          this.cartDrawer.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            if (sectionElement && response.sections?.[section.id]) {
              sectionElement.innerHTML = this.cartDrawer.getSectionInnerHTML(
                response.sections[section.id],
                section.selector
              );
            }
          });
          if (this.cartDrawer.classList.contains("is-empty")) {
            this.cartDrawer.classList.remove("is-empty");
          }
        }
        this.cartDrawer.syncCartBubbles();
        this.showInlineQty();
      } else if (this.cartDrawer) {
        this.cartDrawer.renderContents(response);
        if (this.cartDrawer.classList.contains("is-empty")) {
          this.cartDrawer.classList.remove("is-empty");
        }
      } else {
        window.location = window.routes.cart_url;
      }
    }).catch((error) => {
      console.error("Add to cart error:", error);
      this.handleError("An error occurred. Please try again.");
    }).finally(() => {
      this.submitButton.classList.remove("loading");
      this.submitButton.removeAttribute("aria-disabled");
      const btnText2 = this.submitButton.querySelector(".btn-text");
      const btnSpinner2 = this.submitButton.querySelector(".btn-spinner");
      if (btnText2) btnText2.style.opacity = "1";
      if (btnSpinner2) btnSpinner2.style.opacity = "0";
    });
  }
  showInlineQty() {
    if (!this.inlineQty) return;
    this.submitButton.classList.add("hidden!");
    this.inlineQty.classList.remove("hidden!");
    this.qtyValue.textContent = this.quantity;
  }
  hideInlineQty() {
    if (!this.inlineQty) return;
    this.submitButton.classList.remove("hidden!");
    this.inlineQty.classList.add("hidden!");
    this.cartLineKey = null;
    this.quantity = 0;
  }
  updateQuantity(newQty) {
    if (newQty < 1 || !this.cartLineKey) return;
    const minusBtn = this.querySelector("[data-qty-minus]");
    const plusBtn = this.querySelector("[data-qty-plus]");
    minusBtn?.setAttribute("disabled", "");
    plusBtn?.setAttribute("disabled", "");
    this.qtyValue?.classList.add("hidden");
    this.qtySpinner?.classList.remove("hidden");
    const body = JSON.stringify({
      id: this.cartLineKey,
      quantity: newQty,
      ...this.cartDrawer && {
        sections: this.cartDrawer.getSectionsToRender().map((s) => s.id),
        sections_url: window.location.pathname
      }
    });
    fetch(window.routes.cart_change_url, { ...fetchConfig(), body }).then((response) => response.json()).then((cart) => {
      if (cart.status === 400 || cart.status === 422) {
        console.error("Cart change error:", cart.description);
        return;
      }
      let lineItem = cart.items?.find((item) => item.key === this.cartLineKey);
      if (!lineItem) {
        const variantId = this.cartLineKey.split(":")[0];
        lineItem = cart.items?.find(
          (item) => String(item.variant_id) === variantId
        );
        if (lineItem) this.cartLineKey = lineItem.key;
      }
      if (lineItem) {
        this.quantity = lineItem.quantity;
        this.qtyValue.textContent = this.quantity;
        Toastify({
          text: this.getAttribute("data-cart-updated-text") || "Cart updated",
          duration: 2e3,
          gravity: "bottom",
          position: "right",
          stopOnFocus: true,
          style: { background: "#547744", borderRadius: "8px" }
        }).showToast();
      }
      if (this.cartDrawer && cart.sections) {
        this.cartDrawer.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (sectionElement && cart.sections[section.id]) {
            sectionElement.innerHTML = this.cartDrawer.getSectionInnerHTML(
              cart.sections[section.id],
              section.selector
            );
          }
        });
      }
    }).catch((error) => {
      console.error("Quantity update error:", error);
    }).finally(() => {
      minusBtn?.removeAttribute("disabled");
      plusBtn?.removeAttribute("disabled");
      this.qtySpinner?.classList.add("hidden");
      this.qtyValue?.classList.remove("hidden");
    });
  }
  handleError(message) {
    Toastify({
      text: message,
      duration: 4e3,
      gravity: "bottom",
      position: "right",
      stopOnFocus: true,
      style: { background: "#ef4444", borderRadius: "8px" }
    }).showToast();
    const errorElement = this.querySelector("[data-error-message]");
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.remove("hidden");
      setTimeout(() => {
        errorElement.classList.add("hidden");
      }, 3e3);
    } else {
      alert(message);
    }
  }
}
customElements.define("product-card-wrapper", ProductCardWrapper);
